import { render } from "./Pac.vue?vue&type=template&id=56fbd8c6"
import script from "./Pac.vue?vue&type=script&lang=js"
export * from "./Pac.vue?vue&type=script&lang=js"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__